<template>
  <div class="certificateAuthenticity">
    <el-card class="box-card">
      <div class="box-card-form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入运动员姓名"></el-input>
          </el-form-item>
          <el-form-item prop="certificates_type">
            <el-select v-model="ruleForm.certificates_type" placeholder="请选择证件类型" style="width:100%">
              <el-option :label="item.label" :value="item.value" v-for="(item,index) in certificatesList"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="certificates_number">
            <el-input v-model="ruleForm.certificates_number" placeholder="请输入运动员证件号码"></el-input>
          </el-form-item>
          <el-form-item prop="certificate_numbering">
            <el-input v-model="ruleForm.certificate_numbering" placeholder="请输入运动员证书编号"></el-input>
          </el-form-item>
          <el-form-item>
            <p class="result" v-if="hasCert">查询结果：{{ hasCert }}</p>
          </el-form-item>
          <el-form-item style="text-align:center;">
            <div style="color: grey"><i class="el-icon-info"></i>运动员姓名（必填）,证件号码、证书编号输入一项即可</div>
          </el-form-item>
          <el-form-item style="text-align:center;margin-top: 10px;">
            <el-button
                type="danger"
                style="width:150px;height:40px"
                @click="submitForm('ruleForm')"
                :loading="loading"
            >立即查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px" v-if="dataList.length>0">
      <el-table
          :data="dataList"
          style="width: 100%">
        <el-table-column
            prop="name"
            label="运动员姓名"
            width="180">
        </el-table-column>
        <el-table-column
            prop="gradeStr"
            label="级别"
            width="180">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="showCertificate(scope.$index, scope.row)">查看证书</el-button>
            <span>|</span>
            <el-button type="text" @click="showBadge(scope.$index, scope.row)">查看证章</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog title="证书查看" :visible.sync="zsShow" :width="screenWidth>768?'40%':'90%'" center
               :close-on-click-modal="false">
      <div style="text-align: center;height:650px;overflow:scroll;">
        <el-image
            :src="item"
            v-for="(item,index) in zsList"
            :key="index"
        ></el-image>
      </div>
    </el-dialog>

    <el-dialog title="证章查看" :visible.sync="zzShow" :width="screenWidth>768?'40%':'90%'" center
               :close-on-click-modal="false">
      <div>
        <el-image
            :src="childImgUrl"
            v-if="childImgUrl"
        ></el-image>
        <el-image
            class="img"
            :src="adultImageUrl"
            v-else-if="adultImageUrl"
        ></el-image>
        <no-data v-else/>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {OpenQuery, GetDicData} from "@/api/admin/common.js";
import {cardid, checkPassport, isTWCard, isHKCard} from "@/util/validate.js";
// 验证身份证是否正确
const chnNumber = (rule, value, callback) => {
  if (!value) {
    //callback(new Error("请输入身份证号码"));
  } else {

    if (cardid(value).status) {
      callback();
    } else {
      return callback(new Error(cardid(value).msg));
    }
  }
};
// 验证港澳居民
const chnNumber1 = (rule, value, callback) => {
  if (!value) {
    //callback(new Error("请输入港澳居民来往内地通行证身份证号码"));
  } else {

    if (isHKCard(value).status) {
      callback();
    } else {
      return callback(new Error(isHKCard(value).msg));
    }
  }
};
// 验证台湾身份证
const chnNumber2 = (rule, value, callback) => {
  if (!value) {
    //callback(new Error("请输入台湾居民来往大陆通行证身份证号码"));
  } else {

    if (isTWCard(value).status) {
      callback();
    } else {
      return callback(new Error(isTWCard(value).msg));
    }
  }
};
// 验证护照是否正确
const chnPassport = (rule, value, callback) => {
  if (!value) {
    //callback(new Error("请输入护照号码"));
  } else {

    if (checkPassport(value).errCode) {
      callback();
    } else {
      return callback(new Error(checkPassport(value).errMsg));
    }
  }
};
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        certificates_number: "",
        certificate_numbering: "",
        certificates_type: '1'
      },
      rules: {
        name: [{required: true, message: '请输入运动员姓名', triangle: 'blur'}],
        //certificates_number: [{validator: chnNumber, trigger: "blur"}],
        //certificate_numbering: []
      },
      hasCert: "",
      loading: false,
      certificatesList: [],
      dataList: [],
      zsList: [],
      childImgUrl: "",
      adultImageUrl: "",
      adult: [
        {
          grade: "4",
          base: 1
        },
        {
          grade: "5",
          base: 2
        },
        {
          grade: "6",
          base: 4
        },
        {
          grade: "7",
          base: 8
        },
        {
          grade: "8",
          base: 16
        },
        {
          grade: "9",
          base: 32
        }
      ],
      child: [
        {
          grade: "10",
          base: 1
        },
        {
          grade: "11",
          base: 2
        },
        {
          grade: "12",
          base: 4
        },
        {
          grade: "13",
          base: 8
        },
        {
          grade: "14",
          base: 16
        },
        {
          grade: "15",
          base: 32
        },
        {
          grade: "16",
          base: 64
        }
      ],
      adult_: "",
      child_: "",
      value1: 0,
      value2: 0,
      imgPath: window.apiObj.apiUrl,
      zsShow: false,
      zzShow: false
    };
  },
  watch: {
    "ruleForm.name"(val) {
      if (!val) {
        delete this.ruleForm.name;
      }
    },
    "ruleForm.certificates_number"(val) {
      if (!val) {
        delete this.ruleForm.certificates_number;
      }
    },
    "ruleForm.certificate_numbering"(val) {
      if (!val) {
        delete this.ruleForm.certificate_numbering;
      }
    },
    "ruleForm.certificates_type"(val) {
      this.$refs.ruleForm.clearValidate("certificates_number");
      if (val == "1") {
        this.rules.certificates_number[0].validator = chnNumber;
      } else if (val == "2") {
        this.rules.certificates_number[0].validator = chnNumber1;
      } else if (val == "3") {
        this.rules.certificates_number[0].validator = chnNumber2;
      } else if (val == "4") {
        this.rules.certificates_number[0].validator = chnPassport;
      }
    }
  },
  computed: {
    ...mapGetters(["screenWidth"])
  },
  created() {
    this.getTypeList();
  },
  methods: {
    getTypeList() {
      GetDicData({classCode: "certificates_type"}).then(data => {
        if (data.data.result.length > 0) {
          this.certificatesList = data.data.result;
        }
      });
    },
    submitForm() {
      this.dataList = [];
      this.zsList = [];
      this.hasCert = "";
      this.value1 = 0;
      this.value2 = 0;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          var form = {
            name: this.ruleForm.name,
            certificates_number: this.ruleForm.certificates_number,
            certificate_numbering: this.ruleForm.certificate_numbering
          };
          for (let key in form) {
            if (!form[key]) {
              delete form[key];
            }
          }
          if (Object.keys(form).length > 1) {
            this.loading = true;
            OpenQuery(form)
                .then(data => {
                  if (data.data.success) {
                    this.loading = false;
                    let dataResult = data.data.result;
                    if (dataResult.hasCert) {
                      this.dataList.push(dataResult);
                      //this.hasCert = "证书有效";
                      let list = dataResult.certificateList;
                      let allList = dataResult.allCertificateList;
                      list.forEach(item => {
                        this.zsList.push(this.imgPath + item.certificate_url);
                      })
                      allList.forEach(item => {
                        let flag1 = this.adult.some(record => {
                          return record.grade == item.certificate_grade;
                        })

                        let flag2 = this.child.some(record => {
                          return record.grade == item.certificate_grade;
                        })

                        if (flag1) {
                          this.adult_ = "adult_";
                          this.adult.forEach(j => {
                            if (j.grade == item.certificate_grade) {
                              this.value1 += j.base;
                            }
                          });
                        } else if (flag2) {
                          this.child_ = "child_";
                          this.child.forEach(j => {
                            if (j.grade == item.certificate_grade) {
                              this.value2 += j.base;
                            }
                          });
                        }
                      })
                      if (this.value1) {
                        this.adultImageUrl =
                            "/image/output/" + this.adult_ + this.value1 + ".png";
                        this.zzList.push(this.adultImageUrl);
                      }
                      if (this.value2) {
                        this.childImgUrl =
                            "/image/output/" + this.child_ + this.value2 + ".png";
                        this.zzList.push(this.childImgUrl);
                      }

                    } else {
                      this.hasCert = "证书无效";
                    }
                  }
                })
                .catch(() => {
                  this.loading = false;
                });
          } else {
            this.$message({
              message: "至少填写两项才可查询",
              type: "warning"
            });
          }
        }
      })

    },

    showCertificate() {
      this.zsShow = true;
    },
    showBadge() {
      this.zzShow = true;
    }
  }
};
</script>
<style lang="less" scoped>
.img {
  height: 30vw;
  width: 20vw;
  padding: 10px;
}

.certificateAuthenticity {
  .box-card {
    width: 60%;
    margin: 0 auto;

    .box-card-form {
      margin-top: 40px;
      padding: 10px 40px;

      .result {
        padding-left: 15px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .certificateAuthenticity {
    .enquiry_title {
      padding: 15px 20px;

      h1 {
        font-size: 20px;
      }
    }

    .box-card {
      width: 100%;
    }
  }
}
</style>
